import React from 'react';
import * as Formatting from 'fw/misc/Formatting'

class Int extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

    render() {
        return <React.Fragment>{Formatting.formatInt(this.props.value)}</React.Fragment>
    }
}

export default Int;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/Int.js